import Vue from 'vue';
import checklistGroupService from "./index";

// When the request succeeds
const success = (data, context, index) => {
  context.newChecklistGroup.checklistGroupImages.splice(index, 1);
  toastr.success(context.$t('rentals.detail.checklists.checklist_deleted'));
};

// When the request fails
const failed = (error, context) => {
  toastr.error("Something went wrong");
};

export default (context, id, index) => Vue.$http.delete(`checklists/image/${id}`)
    .then((response) => {
      if (response && response.status === 200) {
        success(response.data, context, index);
      }
    })
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/checklist_group/deleteImage.js